const DEFAULT_BATCH_SIZE = 20;
const DEFAULT_TIMER = 5000;
const STORE_KEY = '@mixpanel/queue';

export default function QueueWithTimer({ batchSize, fireTime, callback }) {
  let stopTimer = true;
  let store = window.localStorage;
  batchSize = batchSize || DEFAULT_BATCH_SIZE;
  fireTime = fireTime || DEFAULT_TIMER;

  if (!callback) return new Error('callback is mandatory for batching');

  function executeFromQueue() {
    const allEvents = JSON.parse(store.getItem(STORE_KEY));
    if (callback && allEvents && allEvents.length) {
      let batch = allEvents.splice(0, batchSize);
      store.setItem(STORE_KEY, JSON.stringify(allEvents));
      callback(batch);
    }
    !stopTimer && setTimeout(executeFromQueue, fireTime);
  }

  return {
    add: event => {
      const oldEvents = JSON.parse(store.getItem(STORE_KEY)) || [];
      oldEvents.push(event);
      const queue = JSON.stringify(oldEvents);
      store.setItem(STORE_KEY, queue);
    },
    stop: () => (stopTimer = true),
    start: () => {
      if (stopTimer) {
        stopTimer = false;
        setTimeout(executeFromQueue, fireTime);
      }
    },
  };
}
